import { ProductQuickInfos } from "entities/products/types/QuickInfos"

import { getProductInformationImport } from "./getProductInformationImport"

const QUICK_INFOS_WIDGET_NAMES: (keyof ProductQuickInfos)[] = [
  "applicationAreas",
  "function",
  "volumetricFlowRange",
  "characteristics"
]

export function getProductInformationQuickInfos({
  productType,
  parentProductType
}: {
  productType: string
  parentProductType?: string
}): ProductQuickInfos {
  const importObj = getProductInformationImport({
    productType,
    parentProductType
  })
  const widgets = importObj?.get("body")

  return Object.fromEntries(
    widgets
      ?.filter(widget =>
        QUICK_INFOS_WIDGET_NAMES.some(
          name => name === widget.get("name")?.toString()
        )
      )
      .map(widget => [widget.get("name"), widget]) || []
  )
}
